(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('carousel-dots')) {
    customElements.define('carousel-dots', class extends HTMLElement {
      connectedCallback() {
        const carousel = this.previousElementSibling;
        const blocks = carousel ? [...carousel.querySelectorAll('.card-carousel--block')] : [];
        const dots = [...this.children];
        if (!blocks.length) return;

        const ratios = new Map();
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => ratios.set(e.target, e.intersectionRatio));
          let best = -1, bestRatio = 0;
          blocks.forEach((b, i) => {
            const r = ratios.get(b) || 0;
            if (r > bestRatio) { bestRatio = r; best = i; }
          });
          if (best === -1) return; // gallery scrolled off screen: keep current dot
          dots.forEach((d, i) => d.toggleAttribute('data-active', i === best));
        }, { threshold: [0, 0.25, 0.5, 0.75, 1] });

        blocks.forEach((b) => this.io.observe(b));
      }
      disconnectedCallback() { this.io?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
